/** The steps a ramp has, which is what a reader can tell apart and what the legend shows. */
export const HEAT_STEPS = 5;

/**
 * A score's step on the ramp, 1 to 5, measured against the busiest cell on screen, so the darkest
 * cell is always the busiest week the reader can see and the grid keeps its contrast when a
 * manager or a shorter window shrinks the range (the prototype's heatStep). A week with no
 * activity has no step at all: it is drawn as nothing, never as the palest shade of something.
 */
export function heatStep(value: number | null, max: number): number {
    if (value === null || value <= 0 || max <= 0) return 0;
    return Math.min(HEAT_STEPS, Math.max(1, Math.ceil((value / max) * HEAT_STEPS)));
}

/** The busiest cell of a grid, which its scale is read off. */
export function busiest(rows: (number | null)[][]): number {
    return rows.reduce(
        (max, row) => row.reduce<number>((m, v) => (v !== null && v > m ? v : m), max),
        0,
    );
}
